import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DoctorService } from '../../services/doctor.service';
import { CommonService } from '../../services/common.service';
import { Serviceprovider } from '../../classes/serviceprovider.interface';
import { AuthService } from '../../authentication/auth.service';
import { MatSnackBar } from '@angular/material';
import { MitterService } from '../../services/mitter.service';
@Component({
  selector: 'app-doctormain',
  templateUrl: './doctormain.component.html',
  styleUrls: ['./doctormain.component.css']
})
export class DoctormainComponent implements OnInit {
  count = 2;
  spqua: string;
  sphoto: any;
  spname: any;
  onlineflag: number;
  loginflag: number;
  id: number;
  tempid;
  sprovider: Serviceprovider[];
  timer: any;
  loading = false;
  action: any;
  msg: string;
  filename: string;
  uploadFile: any;
  hasBaseDropZoneOver = false;
  options: Object = {
  url : 'https://passport.petcart.in/images/userimgs/index.php'
  };
  sizeLimit = 2000000;
  constructor(private doctorservice: DoctorService, private commonService: CommonService,
  private authService: AuthService, private router: Router, public snackBar: MatSnackBar,
  private mitterService: MitterService) {
    this.timer = setInterval(() => this.timedelay(), 1000);
   }

  ngOnInit() {

  }
  timedelay() {
    this.count = this.count - 1;
    if (this.count === 0) {
      const udata = this.commonService.getUserDataLocally();
      this.id = udata.uid;
      if (this.id !== undefined) {
        this.loginflag = 1;
        this.doctorservice.getServiceproviderownId(this.id)
        .subscribe(
          (x: Serviceprovider[]) => {
            this.sprovider = x;
            if (this.sprovider && this.sprovider.length > 0) {
               this.spname = this.sprovider[0].name;
                this.sphoto = this.sprovider[0].photo;
               this.spqua = this.sprovider[0].qualification;
                this.checkOnlineStatus(this.sprovider[0].id);
                clearInterval(this.timer);
            }
        });
      } else {
        this.loginflag = 0;
      }
    }
   }
  checkOnlineStatus(spid) {
    this.doctorservice.checkOwnLoginstatus(spid)
    .subscribe(
      (x) => {
        if (x && x.length > 0) {
          this.tempid = x[0].id;
          this.onlineflag = 1;
        } else {
          this.onlineflag = 0;
        }
      }
    );
  }
  goOnline() {
    this.doctorservice.postOnline(this.sprovider[0].id)
    .subscribe(
      (a) => {
        this.tempid = a.id;
        this.onlineflag = 1;
     });
  }
  goOffline() {
    this.doctorservice.deleteOnline(this.tempid)
    .subscribe(
      (x) => {
        this.onlineflag = 0;
      });
  }
  logOut() {
    this.authService.logout();
    this.mitterService.logout();
    this.router.navigate(['']);
  }
   /* for file upload*/

   handleUpload(data): void {
    if (data && data.response) {
        data = JSON.parse(data.response);
        this.uploadFile = data;
        this.filename = data.originalName;
        this.uploadImage(this.filename);
     }
    }
    uploadImage(file) {
      this.loading = true;
      this.commonService.updateimage(this.id, file )
      .subscribe(
        (x) => {
          this.uploadServiceproviderImage(file);
 
        });
    }
    uploadServiceproviderImage(file) {
      this.doctorservice.updateServiceproviderImage(this.sprovider[0].id, file)
      .subscribe(
        (x) => { 
          this.loading = false;
          this.msg = 'Image Uploaded Successfully';
          this.openSnackBar();
          this.sphoto = file;
        });
    }
    openSnackBar() {
      this.snackBar.open(this.msg , this.action, {
        duration: 4000,
      });
    }

    fileOverBase(e: any): void {
      this.hasBaseDropZoneOver = e;
    }

    beforeUpload(uploadingFile): void  {
      if (uploadingFile.size >  this.sizeLimit) {
        uploadingFile.setAbort();
        alert('File is too large');
      }
    }
}
